import React from 'react';
import { Box, Typography, Paper, TextField, Button, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';

const WikiWasteSearch = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        WikiWaste Search
      </Typography>
      <Paper sx={{ p: 3 }}>
        <TextField
          fullWidth
          placeholder="Search WikiWaste..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Button variant="contained">Search</Button>
              </InputAdornment>
            )
          }}
          sx={{ mb: 2 }}
        />
        <Typography variant="body2" color="text.secondary">
          Search results will appear here...
        </Typography>
      </Paper>
    </Box>
  );
};

export default WikiWasteSearch;